export default {
  data() {
    return {
      ready: false, // 🔹 Evita mostrar la vista antes de cargar datos
      loading: false,
      superAdmins: [],
      filters: {},
      pagination: {},
      showDeleteConfirm: false,
      adminToDelete: null
    };
  },
  created() {
    this.$setPageTitle(this.$t('superAdmin.index.title'));
    this.$setBreadcrumbs([{ label: this.$t('breadcrumbs.superAdmin.index'), route: {} }]);
    this.fetchSuperAdmin();
  },
  methods: {
    fetchSuperAdmin(params = {}) {
      this.loading = true;
      const query = Object.assign({}, this.filters, params);

      API.superAdmin.index(query).then(({ data, meta }) => {
        this.superAdmins = data;
        this.pagination = meta;
        this.ready = true;
        this.loading = false;
      }).catch(error => {
        console.error("Error al obtener superAdmins:", error);
        this.loading = false;
      });
    },

    applyFilters() {
      this.fetchSuperAdmin();
    },

    clearFilters() {
      this.filters = {};
      this.fetchSuperAdmin();
    },

    confirmDelete(admin) {
      this.adminToDelete = admin;
      this.showDeleteConfirm = true;
    },

    deleteSuperAdmin() {
      if (!this.adminToDelete) return;
      API.superAdmin.delete(this.adminToDelete.id).then(() => {
        this.$notifications.success(this.$t('alerts.deleted'));
        this.fetchSuperAdmin();
        this.showDeleteConfirm = false;
        this.adminToDelete = null;
      }).catch(error => {
        console.error("Error al eliminar usuario:", error);
      });
    }
  }
};
